import axios from "axios";

const BASE_URL =
  "https://pmlzsyafmk.execute-api.ap-south-1.amazonaws.com/default";

export const eligibilityClient = axios.create({
  baseURL: BASE_URL,
});

export const fetchEligibility = async (user_id) => {
  try {
    const response = await eligibilityClient.post("/reportEligibility", {
      user_id: user_id,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching eligibility:", error);
    throw error;
  }
};
